import React from 'react'
import './PreCheckTeacherModal.scss'

import StudentInstruction from './StudentInstruction'
import { getCopyByGradeband } from '../../../services/ThemingService'
import { COPY_STRINGS } from '../../../constants/translatedCopy'

export default function PreCheckTeacherModal(props) {

  const { StudentView, handleRetry, setInTroubleshootView } = props

  const copy_strings = getCopyByGradeband(COPY_STRINGS, "student_raise_hand"); 

  return (
    <div className='ready-module-teacher-modal'>
      <div className='__student-content'>
        <StudentInstruction>
          { StudentView && <StudentView/> }
          { handleRetry && <button onClick={handleRetry}>{copy_strings.try_again}</button> }
          <button 
            className='teacher-troubleshoot-button' 
            onClick={()=>{setInTroubleshootView(true)}}>
              {copy_strings.teacher_troubleshoot} 
          </button>
        </StudentInstruction>
      </div>
    </div>
  )
}